import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DragDropService {
  private _lastNodeData: any = null;
  private _sourceTreeId: string = null;
  private _sourceTreeType: string = null;

  setLastNode(nodeData: any, treeId?: string, treeType?: string) {
    this._lastNodeData = nodeData;
    this._sourceTreeId = treeId;
    this._sourceTreeType = treeType;
  }
  getLastNode() {
    return this._lastNodeData;
  }
  getSourceTreeId() {
    return this._sourceTreeId;
  }
  getSourceTreeType() {
    return this._sourceTreeType;
  }
  clearLastNode() {
    this._lastNodeData = null;
    this._sourceTreeId = null;
    this._sourceTreeType = null;
  }
}
